import { jsxs, jsx } from "react/jsx-runtime";
import { useExternalPopupConfig } from "../../../utils/ExternalPopupConfigProvider/ExternalPopupConfigProviderClient.js";
import { getLinkBehavior } from "../../../utils/targetLinkBehavior/getLinkBehavior.js";
import { MarketingTypography } from "../MarketingTypography/index.js";
import { getExternalLinkProps, createButtonRow } from "./lib.js";
import { CaptionButtonContainer, CaptionTextStyle, BelowFeatureTilesButton, ButtonGroupContainer, ButtonRow, BGButton } from "./styles.js";
const CaptionDiscalimerSection = ({
  data,
  contentAlignment,
  globalTextColor,
  viewName
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const { select_card_style_variant, button_group } = data;
  const { disclaimer_caption, button_config } = data.below_feature_tiles;
  const hasCaption = disclaimer_caption.replace(/\s/g, "").length > 0;
  const { externalLinkTranslations } = useExternalPopupConfig();
  let externalLinkProps = {};
  if (externalLinkTranslations) {
    externalLinkProps = getExternalLinkProps(externalLinkTranslations);
  }
  const featureLink = button_config == null ? void 0 : button_config.text_and_url;
  const featureLinkProps = featureLink ? getLinkBehavior(
    featureLink == null ? void 0 : featureLink.external_site,
    featureLink == null ? void 0 : featureLink.same_tab_domain
  ) : null;
  return /* @__PURE__ */ jsxs(
    CaptionButtonContainer,
    {
      contentAlignment,
      "data-testid": `${viewName}-caption-disclaimer`,
      hasCaption,
      children: [
        disclaimer_caption && /* @__PURE__ */ jsx(CaptionTextStyle, { children: /* @__PURE__ */ jsx(
          MarketingTypography,
          {
            variant: "caption",
            isMarkdown: true,
            sx: {
              color: globalTextColor
            },
            children: disclaimer_caption
          }
        ) }),
        select_card_style_variant === "feature_variant" && ((_a = button_config == null ? void 0 : button_config.text_and_url) == null ? void 0 : _a.url) && ((_b = button_config == null ? void 0 : button_config.text_and_url) == null ? void 0 : _b.title) && /* @__PURE__ */ jsx(
          BelowFeatureTilesButton,
          {
            background: (_c = button_config.color_config.background_color) == null ? void 0 : _c.hex,
            color: ((_d = button_config.color_config.text_color) == null ? void 0 : _d.hex) || globalTextColor,
            href: (_e = button_config == null ? void 0 : button_config.text_and_url) == null ? void 0 : _e.url,
            hasExternalLinkWarning: (_f = button_config == null ? void 0 : button_config.text_and_url) == null ? void 0 : _f.external_site,
            target: featureLinkProps == null ? void 0 : featureLinkProps.target,
            ...externalLinkProps,
            children: (_g = button_config == null ? void 0 : button_config.text_and_url) == null ? void 0 : _g.title
          }
        ),
        select_card_style_variant === "general_variant" && Array.isArray(button_group) && /* @__PURE__ */ jsx(ButtonGroupContainer, { contentAlignment, children: createButtonRow(button_group, (slice) => /* @__PURE__ */ jsx(ButtonRow, { children: slice.map((button, index) => {
          var _a2, _b2;
          const { text_and_url, color_config } = button;
          return /* @__PURE__ */ jsx(
            BGButton,
            {
              background: (_a2 = color_config == null ? void 0 : color_config.background_color) == null ? void 0 : _a2.hex,
              color: (_b2 = color_config == null ? void 0 : color_config.text_color) == null ? void 0 : _b2.hex,
              href: text_and_url == null ? void 0 : text_and_url.url,
              hasExternalLinkWarning: text_and_url == null ? void 0 : text_and_url.external_site,
              target: featureLinkProps == null ? void 0 : featureLinkProps.target,
              ...externalLinkProps,
              children: text_and_url == null ? void 0 : text_and_url.title
            },
            `${text_and_url.title}-${index}`
          );
        }) }, slice[0].text_and_url.title)) })
      ]
    }
  );
};
export {
  CaptionDiscalimerSection
};
